import { ChangeDetectorRef, Component, ElementRef, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'tm-recaptcha',
  templateUrl: './tm-recaptcha.component.html',
  styleUrls: ['./tm-recaptcha.component.scss']
})
export class TmRecaptchaComponent implements OnInit {
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;

  valid_catpcha;
  is_captcha_valid: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog_ref: MatDialogRef<TmRecaptchaComponent>,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.addRecaptchaScript();
  }
  renderReCaptch() {
    window['grecaptcha'].render('tm-recaptcha', {
      'sitekey': environment.RECAPCHA_KEY,
      'callback': (response) => {

        this.valid_catpcha = response;
        this.is_captcha_valid = true;
        this.close()

      },
      'expired-callback': (response) => {

        this.expiredCallback();
      },
    });
    // let interval = setInterval(() => {
    //
    //   if (this.is_captcha_valid) {
    //     this.dialog_ref.close(true)
    //     clearInterval(interval)
    //   }
    // }, 1000)
  }
  close(): void {
    this.ngZone.run(() => {
      this.dialog_ref.close(true);
    });
  }
  expiredCallback() {
    this.valid_catpcha = "";
    this.is_captcha_valid = false

  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptch();
    }
    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { obj.renderReCaptch(); return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&amp;render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));
  }


}
